import { useSelector } from 'react-redux';
import { SearchStatus } from 'Utils/Constants/TotalTypes';
import Box from '../Box';

export default function ListStatuses() {
  const { totalStatuses } = useSelector((state) => ({
    totalStatuses: state.setting.totalStatuses,
  }));
  return (
    <>
      {(totalStatuses && totalStatuses.length !== 0) &&
        <Box
          title={"جستجو وضعیت‌ها"}
          info={"فیلد‌های جستجو نوبت در داشبورد بر‌اساس وضعیت‌های موجود در سیستم"}
          body={
            <div className='search-status-show'>
              {
                SearchStatus.filter(i => i.id !== 1).map((items, index) => {
                  return (
                    <>
                      {
                        totalStatuses.map(i => {
                          if(items.access.includes(i.id) && i.status) return true;
                        }).reduce((a, b) => {if(a || b) return true; else return false;}) &&
                        <div className='each-item'>
                          <p>
                            {items.name}
                          </p>
                          <div>
                            <small className='ms-1'>{"شامل :"}</small>
                            {
                              items.access.map(i => {
                                return (
                                  <>
                                    {
                                      totalStatuses.find(t => t.id === i).status &&
                                      <small className='each-status'>
                                        {
                                          totalStatuses.find(t => t.id === i).name
                                        }
                                      </small>
                                    }
                                  </>
                                )
                              })
                            }
                          </div>
                        </div>
                      }
                    </>
                  )
                })
              }
            </div>
          }
        />
      }
    </>
  );
}